import { render, staticRenderFns } from "./PlayLiveStreamOrVideo.vue?vue&type=template&id=336c7d02&scoped=true&"
import script from "./PlayLiveStreamOrVideo.vue?vue&type=script&lang=js&"
export * from "./PlayLiveStreamOrVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlayLiveStreamOrVideo.vue?vue&type=style&index=0&id=336c7d02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c7d02",
  null
  
)

export default component.exports